module.exports = __webpack_public_path__ + "assets/img/small_suspension_icon.87edc4a9.svg";